<template>
  <div class="e4Warp">
    <div class="inner">
      <versionNav></versionNav>
      <div style='width:100%;height:106px'></div>

      <div class="e5title"><img
          src="../assets/img/e5title.png"
          width="941"
          height="128"
        /></div>
      <div class="e5lt1">为帮助新手玩家更快、更好的成长，即日起，只要完成[主线]纳米觉醒，便可获得海量永久武器！</div>
      <div class="clearfloat"></div>
      <div class="e5main">
        <div class="h50"></div>
        <div class="e5zw e5zw1">
          <div class="zwname">危机前夕</div>
          <div class="zwmain">
            <span class="zw">生涯模式“危机前夕”地图取得胜利</span>
            <span class="jl">Super90（永久）、斯泰尔scout（永久）</span>
          </div>
        </div>
        <div class="e5zw e5zw2">
          <div class="zwname">突出重围</div>
          <div class="zwmain">
            <span class="zw">生涯模式“突出重围”地图取得胜利</span>
            <span class="jl">传承核心x5、USP（永久）</span>
          </div>
        </div>
        <div class="e5zw e5zw3">
          <div class="zwname">纳米觉醒</div>
          <div class="zwmain">
            <span class="zw">生涯模式“纳米觉醒”地图取得胜利</span>
            <span class="jl">传承核心x5、经验五倍卡x20</span>
          </div>
        </div>
        <div class="clearfloat"></div>
        <div class="explain">除此之外，创建角色即可获得<span>“SCAR-L（永久）、M249 SAW（30天）、M1911（永久）、Thor-初号机、09式主战机甲、KS-36Z、AT-47、20000金币”</span>的豪华新手大礼。海量点券道具及永久武器升级即可获得，所有奖励将在角色升级后，即时发放至玩家的个人仓库。</div>
        <div class="clearfloat"></div>
      </div>
      <div class="clearfloat"></div>
      <div class="e5table">
        <div class="clearfloat"></div>
        <table>
          <thead>
            <tr>
              <th width="160">等级</th>
              <th width="180">金币奖励</th>
              <th width="670">道具奖励</th>
            </tr>
          </thead>
          <tbody>
            <tr class="hei">
              <td>1</td>
              <td>20000</td>
              <td>SCAR-L（永久）、M249 SAW（30天）、M1911（永久）</td>
            </tr>
            <tr class="bai">
              <td>2</td>
              <td>2000</td>
              <td>UMP.45（3天）、SMG-弹匣+10（3天）</td>
            </tr>
            <tr class="hei">
              <td>3</td>
              <td>3000</td>
              <td>SMG-增重枪托（3天）、白银子弹*10</td>
            </tr>
            <tr class="bai">
              <td>4</td>
              <td>4000</td>
              <td>LV1稀有金属（普通）*2、移动装置（3天）</td>
            </tr>
            <tr class="hei">
              <td>5</td>
              <td>5000</td>
              <td>天空杀手时空箱（1阶）、SMG-钼铬枪管（3天）</td>
            </tr>
            <tr class="bai">
              <td>6</td>
              <td>6000</td>
              <td>复活币*10、逃跑清除卡*1</td>
            </tr>
            <tr class="hei">
              <td>7</td>
              <td>7000</td>
              <td>大喇叭*5、白银子弹*10</td>
            </tr>
            <tr class="bai">
              <td>8</td>
              <td>8000</td>
              <td>1级通用材料*75、870MCS组件*19</td>
            </tr>
            <tr class="hei">
              <td>9</td>
              <td>9000</td>
              <td>供弹器（3天）、白银子弹*10</td>
            </tr>
            <tr class="bai">
              <td>10</td>
              <td>10000</td>
              <td>复活币*10、白银子弹*10</td>
            </tr>
            <tr class="hei">
              <td>11</td>
              <td>11000</td>
              <td>破军AN94（3天）、AR-弹匣+2（3天）</td>
            </tr>
            <tr class="bai">
              <td>12</td>
              <td>12000</td>
              <td>2级通用材料*180、退魔MP5组件*38</td>
            </tr>
            <tr class="hei">
              <td>13</td>
              <td>13000</td>
              <td>自动装填装置（3天）、高爆手雷（3天）</td>
            </tr>
            <tr class="bai">
              <td>14</td>
              <td>14000</td>
              <td>静音装置（3天）、LV2稀有金属（普通）*2</td>
            </tr>
            <tr class="hei">
              <td>15</td>
              <td>15000</td>
              <td>金币五倍卡*2、基础晶能电源Mk.1</td>
            </tr>
            <tr class="bai">
              <td>16</td>
              <td>16000</td>
              <td>力量增幅器II型（3天）、复活币*10</td>
            </tr>
            <tr class="hei">
              <td>17</td>
              <td>17000</td>
              <td>AR-度铬枪管（3天）、白银子弹*10</td>
            </tr>
            <tr class="bai">
              <td>18</td>
              <td>18000</td>
              <td>2级通用材料*150、神行QBU88组件*38</td>
            </tr>
            <tr class="hei">
              <td>19</td>
              <td>19000</td>
              <td>ID识别卡*1、大喇叭*5</td>
            </tr>
            <tr class="bai">
              <td>20</td>
              <td>20000</td>
              <td>逃跑清除卡*1、白银子弹*10</td>
            </tr>
          </tbody>
        </table>
        <div class="jqsc"><a
            href="http://qqsm.zygames.com/t2/qmib/rank.html"
            target="_blank"
          ><img
              src="../assets/img/jllist.png"
              width="365"
              height="67"
              alt="季券商城"
              title="查看升级奖励列表"
            /></a></div>
      </div>
      <div class="h50"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "e4"
}
</script>

<style scoped>
@import "./pagesCss/e3.css"
</style>


// WEBPACK FOOTER //
// src/pages/e4.vue